export default __webpack_public_path__ + "static/media/2BARBAS.75488791.png";